export function getDateYear(inputDate) {
  // Parse input date string
  const date = new Date(inputDate);

  // Extract date components
  const year = date.getFullYear();

  return year;
}

export function formatDate(inputDate, format = 'long') {
  return Intl.DateTimeFormat('en-US', {
    month: format === 'long' ? 'long' : '2-digit',
    day: format === 'long' ? 'numeric' : '2-digit',
    year: 'numeric',
    // dateStyle: format,
  }).format(new Date(inputDate));
}

export function getTimeAgo(date) {
  const rtf = new Intl.RelativeTimeFormat('en-US', { numeric: 'auto', style: 'narrow' });
  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);

  const units = [
    ['year', 31536000],
    ['month', 2592000],
    ['week', 604800],
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
    ['second', 1],
  ];

  for (const [unit, value] of units) {
    const diff = Math.floor(seconds / value);
    if (Math.abs(diff) >= 1) return rtf.format(-diff, unit);
  }
  return 'Now';
}
